import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip } from '@mui/material';

export default function Step3History({ data }) {
  if (!data) return null;

  const staffList = Object.values(data);

  const formatDate = (dateString) => {
    if (!dateString) return 'Present';
    const parts = dateString.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateString;
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>3. Employment History Timeline</Typography>
      <Typography variant="body2" color="textSecondary" mb={3}>
        Review the parsed chronological events (HIRE, PROM, CESS) for each staff member.
      </Typography>

      {staffList.map(staff => (
        <Box key={staff.staff_code} mb={4}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {staff.full_name} ({staff.staff_code})
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                  <TableCell><strong>Type</strong></TableCell>
                  <TableCell><strong>From</strong></TableCell>
                  <TableCell><strong>To</strong></TableCell>
                  <TableCell><strong>Department</strong></TableCell>
                  <TableCell><strong>Branch</strong></TableCell>
                  <TableCell><strong>Job Title</strong></TableCell>
                  <TableCell><strong>Grade</strong></TableCell>
                  <TableCell><strong>Salary</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(staff.events || []).map((event, idx) => (
                  <TableRow key={idx}>
                    <TableCell>
                      <Chip 
                        label={event.record_type} 
                        size="small" 
                        color={event.record_type === 'HIRE' ? 'success' : event.record_type === 'CESS' ? 'error' : 'primary'} 
                      />
                    </TableCell>
                    <TableCell>{formatDate(event.record_date)}</TableCell>
                    <TableCell>{event.record_type === 'CESS' ? '-' : formatDate(event.effective_to)}</TableCell>
                    <TableCell>{event.department || '-'}</TableCell>
                    <TableCell>{event.branch || '-'}</TableCell>
                    <TableCell>{event.job_title || '-'}</TableCell>
                    <TableCell>{event.grade || '-'}</TableCell>
                    <TableCell>{event.basic_salary || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ))}
    </Box>
  );
}
